import { render, staticRenderFns } from "./imgBlog.vue?vue&type=template&id=10587c40&"
import script from "./imgBlog.vue?vue&type=script&lang=js&"
export * from "./imgBlog.vue?vue&type=script&lang=js&"
import style0 from "./imgBlog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports